export function copy(arr) {
  if (arr === undefined || arr.length === 0) {
    return []
  }
  const newArr = []
  for (let i = 0; i < arr.length; i++) {
    newArr.push(arr[i])
  }
  return newArr
}

export function copyRange(arr, beginIndex, endIndex) {
  if (arr === undefined || arr.length === 0) {
    return []
  }
  const newArr = []
  for (let i = 0; i < arr.length; i++) {
    if (i >= beginIndex && i < endIndex) {
      newArr.push(arr[i])
    }
  }
  return newArr
}

export function isEmpty(arr) {
  return arr === undefined || arr.length === 0
}

export function indexOf(arr, equalFunc) {
  for (let i = 0; i < arr.length; i++) {
    if (equalFunc(arr[i])) {
      return i
    }
  }
  return -1
}

export function min(arr) {
  let min
  for (let i = 0; i < arr.length; i++) {
    const value = arr[i]
    if (min === undefined) {
      min = value
    } else {
      min = Math.min(min, value)
    }
  }
  return min
}

export function max(arr) {
  let max
  for (let i = 0; i < arr.length; i++) {
    const value = arr[i]
    if (max === undefined) {
      max = value
    } else {
      max = Math.max(max, value)
    }
  }
  return max
}

export function removeIf(arr, func) {
  const copiedArr = []
  for (let i = 0; i < arr.length; i++) {
    const item = arr[i]
    if (func(item)) {
      continue
    }
    copiedArr.push(item)
  }
  return copiedArr
}

export function removeAll(source, target) {
  if (isEmpty(source) || isEmpty(target)) {
    return []
  }
  const result = []
  for (let i = 0; i < source.length; i++) {
    const s = source[i]
    if (target.indexOf(s) > -1) {
      continue
    }
    result.push(s)
  }
  return result
}

export function sort(array, orderFunc) {
  if (array === undefined || array.length < 2) {
    return
  }
  array.sort((item1, item2) => {
    const order1 = orderFunc(item1)
    const order2 = orderFunc(item2)
    if (order1 === order2) {
      return 0
    }
    if (order1 < order2) {
      return -1
    }
    return 1
  })
}

export function removeDuplicated(arr) {
  for (let i = 0; i < arr.length; i++) {
    for (let j = i + 1; j < arr.length; j++) {
      if (arr[i] === arr[j]) {
        arr.splice(j, 1)
        j--
      }
    }
  }
  return arr
}

export function equals(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false
  }
  for (let i = 0; i < arr1.length; i++) {
    const v1 = arr1[i]
    const v2 = arr2[i]
    if (v1 !== v2) {
      return false
    }
  }
  return true
}

export function equalsWithFunc(arr1, arr2, compareFunc) {
  if (arr1 === undefined && arr2 === undefined) {
    return true
  }
  if (arr1 === undefined || arr2 === undefined) {
    return false
  }
  if (arr1.length !== arr2.length) {
    return false
  }
  for (let i = 0; i < arr1.length; i++) {
    const v1 = arr1[i]
    const v2 = arr2[i]
    if (!compareFunc(v1, v2)) {
      return false
    }
  }
  return true
}
